export default "__VITE_ASSET__DTeUIASt__"